// Admin article preview — same ArticleRenderer used by members, plus a
// banner outside the canonical layout (§16/§31).
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import api from "@/modules/growing-circle/lib/api";
import ArticleRenderer from "@/modules/growing-circle/pages/articles/ArticleRenderer";

export default function AdminArticlePreview() {
  const { id } = useParams();
  const [state, setState] = useState({ loading: true });
  useEffect(() => {
    api.get(`/admin/articles/${id}/preview`)
      .then(({ data }) => {
        // Merge current fields with any active draft revision content.
        const merged = { ...(data.article?.fields || {}), ...(data.revision?.content || {}) };
        setState({ fields: merged, publishAt: data.revision?.content?.publish_at || data.article?.publish_at, loading: false });
      })
      .catch(() => setState({ error: true, loading: false }));
  }, [id]);
  if (state.loading) return <p className="p-8 text-muted-foreground">Loading preview…</p>;
  if (state.error) return <p className="p-8 text-destructive">Impossibile caricare l'anteprima.</p>;
  return (
    <div data-testid="admin-article-preview">
      <div className="article-preview-banner" data-testid="preview-banner">ANTEPRIMA — NON PUBBLICATO</div>
      <ArticleRenderer fields={state.fields} publishedAt={state.publishAt || new Date().toISOString()} />
    </div>
  );
}
